import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "error-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "content" }, [
      _createElementVNode("h2", {
        class: "header",
        "data-text": "404",
        style: {"background":"transparent"}
      }, " 404 "),
      _createElementVNode("h4", { "data-text": "Opps! Page not found" }, " Opps! Page not found "),
      _createElementVNode("p", null, " Please contract to the adminstrator ")
    ], -1)
  ]))]))
}